<template>
  <div v-loading="fileLoading">
    <div v-if="list && list.length > 0">
      <ul class="size16 part31">
        <li
          v-for="(item, index) in list"
          :key="index"
          class="flexs"
          @click="view(item)"
        >
          <div class="questionBank-left">
            <img
              v-if="item.FileExt == '.docx' || item.FileExt == '.doc'"
              src="@/assets/img/home/29.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.zip'"
              src="@/assets/img/home/30.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.ppt'"
              src="@/assets/img/home/31.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.rar'"
              src="@/assets/img/home/32.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.txt'"
              src="@/assets/img/home/33.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.7z'"
              src="@/assets/img/home/34.png"
              alt=""
            />
            <img
              v-if="item.FileExt == '.pdf'"
              src="@/assets/img/home/35.png"
              alt=""
            />
          </div>
          <div class="questionBank-right">
            <p class="name">
              <span>{{ item.FileName?.split('.')[0] }}</span>
            </p>
            <div class="content">
              <div>{{ item.FileExt }}</div>
              <div>{{ item.FileSizeTxt }}</div>
            </div>
          </div>
        </li>
      </ul>
      <el-pagination
        class="center mt30 mb70"
        @current-change="(page) => getList(page)"
        background
        :page-size="18"
        hide-on-single-page
        layout="prev, pager, next"
        :total="count"
      >
      </el-pagination>
    </div>
    <el-empty v-if="list.length == 0" description="暂无资料" :image="empty1" />
  </div>
</template>
<script>
import { Course_GetFileList, Course_GetFileDownUrl } from "@/api/course";
export default {
  name: "filList",
  data() {
    return { fileLoading: false, PageIndex: 1, list: [], count: 0 };
  },
  props: {
    id: [String, Number],
  },
  watch: {
    id: {
      deep: true,
      handler(v) {
        this.getList(1);
        // this.list = v.map(item => ({ ...item, Ext: item.Ext.replace('.', ''), downLoading: false }))
      },
    },
  },
  components: {},
  created() {
    this.getList(1);
  },
  methods: {
    getList(page) {
      this.fileLoading = true;
      Course_GetFileList({
        CourseID: this.id,
        PageSize: 18,
        PageIndex: page,
      })
        .then((res) => {
          this.fileLoading = false;
          this.list = res.data;
          this.count = res.count || this.list.length;
        })
        .catch(() => {});
    },
    // down(item, index) {
    //   const { KJID, FileTitle } = item;
    //   console.log(FileTitle);
    //   const { PCID, KCID, CID } = this.$route.query;
    //   const ReID = PCID || KCID || CID;
    //   this.list[index].downLoading = true;
    //   //  ReType 1学习 2培训 3直播 4资讯
    //   let ReType = 1;
    //   if (PCID) {
    //     ReType = 2;
    //   }
    //   if (CID) {
    //     ReType = 3;
    //   }
    //   /* eslint-disable */
    //   Course_GetFileDownUrl({ CourseID: this.id, FileID: item.FileID }).then(
    //     ({ data }) => {
    //       const { SignCode, SignToken } = data;
    //       this.$ajax({
    //         method: "get",
    //         url: "Study/KJ_DownFile",
    //         responseType: "arraybuffer",
    //         headers: { "Content-Type": "application/octet-stream" },
    //         params: { ReID, ReType, SignCode, SignToken, KJID },
    //         myData: { type: "file" },
    //       })
    //         .finally(() => {
    //           this.list[index].downLoading = false;
    //         })
    //         .then((data) => {
    //           if (data.byteLength < 100) {
    //             return this.$message.error("下载错误");
    //           }
    //           const blob = new Blob([data], {
    //             type: "application/vnd.ms-excel;charset=utf-8",
    //           });
    //           const objectUrl = URL.createObjectURL(blob);
    //           const link = document.createElement("a");
    //           link.style.display = "none";
    //           link.href = objectUrl;
    //           link.setAttribute("download", decodeURIComponent(FileTitle));
    //           document.body.appendChild(link);
    //           link.click();
    //           document.body.removeChild(link);
    //         });
    //     }
    //   );
    // },
    view(item) {
      Course_GetFileDownUrl({ CourseID: this.id, FileID: item.FileID }).then(
        (res) => {
          window.open(res.data.DownUrl, "_blank");
        }
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.part31 {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  align-items: center;
  .flexs {
    width: 437px;
    height: 103px;
    border-radius: 10px;
    border: 1px solid #e9ecf0;
    display: flex;
    align-items: center;
    gap: 20px;
    cursor: pointer;

    .questionBank-left {
      width: 42px;
      height: 43px;
      img {
        width: 42px;
        height: 43px;
      }
    }
    .questionBank-right {
      flex: 1;
      margin-top: -14px;
      .name {
        width: 300px;
        display: -webkit-box;
        overflow: hidden; /* 超出的文本隐藏 */
        text-overflow: ellipsis; /* 溢出用省略号显示 */
        -webkit-box-orient: vertical; /* 垂直排列子元素 */
        -webkit-line-clamp: 1; /* 显示的行数 */
        font-weight: 400;
        font-size: 20px;
        color: #333333;
      }
      .content {
        margin-top: 10px;
        display: flex;
        gap: 30px;
        font-size: 16px;
        color: #999999;
      }
    }
    &:hover {
      .questionBank-right {
        .name {
          color: #1d79ff;
          span {
            border-bottom: 1px solid #1d79ff;
          }
        }
      }
    }
  }
}
</style>
